import React, { useState } from "react";
import Apar1 from "../../../asset/APAR-1.png";
import Apar2 from "../../../asset/APAR-2.png";
import Parkiran from "../../../asset/PARKIRAN.png";
import SatuSetengah from "../../../asset/SATU-SETENGAH.png";
import Basement from "../../../asset/BASEMENT.png";
import AparIcon from "../../../asset/fire-icon.png";
import Check from "../../../asset/approve-icon.png";
import Cross from "../../../asset/cancel-icon.png";
import Barcode from "../../../asset/qr-icon.png";
import "./Apar.css";
import { useApar } from "./useApar";
import { bulan, tahun, apar, mock } from "../../../constant";
import moment from "moment";
import PopUpComponent from "../../../component/PopUpComponent/PopUpComponent";
import QRCode from "react-qr-code";
import AccordionApar from "../../../component/AccordionApar/AccordionApar";

const TABS = [
  ["monitoring", "Monitoring"],
  ["checksheet", "Checksheet"],
  ["InOut", "In / Out"],
  ["Inventory", "Inventory"],
];

const FLOOR_IMAGES = {
  1: Apar1,
  "SATU SETENGAH": SatuSetengah,
  2: Apar2,
  BASEMENT: Basement,
  PARKIRAN: Parkiran,
};

const points = [
  { id: "1", style: { top: "72%", left: "6%" } },
  { id: "2", style: { top: "62%", left: "14%" } },
  { id: "3", style: { top: "72%", left: "14%" } },
  { id: "4", style: { top: "61%", left: "30%" } },
  { id: "5", style: { top: "71%", left: "29%" } },
  { id: "6", style: { top: "81%", left: "30%" } },
  { id: "7", style: { top: "80%", left: "47%" } },
  { id: "8", style: { top: "62%", left: "46.8%" } },
  { id: "9", style: { top: "80%", left: "55%" } },
  { id: "10", style: { top: "64%", left: "61.5%" } },
  { id: "11", style: { top: "80%", left: "71%" } },
  { id: "12", style: { top: "64%", left: "71%" } },
  { id: "13", style: { top: "41%", left: "74%" } },
  { id: "14", style: { top: "17%", left: "75%" } },
  { id: "15", style: { top: "18%", left: "69%" } },
  { id: "16", style: { top: "19%", left: "56%" } },
  { id: "17", style: { top: "19%", left: "49%" } },
  { id: "18", style: { top: "28%", left: "43%" } },
  { id: "19", style: { top: "47%", left: "47%" } },
  { id: "20", style: { top: "42%", left: "58%" } },
  { id: "21", style: { top: "55%", left: "67%" } },
  { id: "22", style: { top: "77%", left: "15%" } },
  { id: "23", style: { top: "76%", left: "54%" } },
  { id: "24", style: { top: "76%", left: "76%" } },
  { id: "25", style: { top: "14%", left: "85%" } },
  { id: "26", style: { top: "53.8%", left: "84%" } },
  { id: "27", style: { top: "56%", left: "72%" } },
  { id: "28", style: { top: "57%", left: "61%" } },
  { id: "29", style: { top: "23%", left: "71%" } },
  { id: "30", style: { top: "75%", left: "86%" } },
  { id: "31", style: { top: "14%", left: "90%" } },
  { id: "32", style: { top: "61%", left: "24.5%" } },
  { id: "33", style: { top: "7%", left: "21%" } },
  { id: "34", style: { top: "7%", left: "36%" } },
  { id: "35", style: { top: "20%", left: "36%" } },
  { id: "36", style: { top: "34%", left: "36%" } },
  { id: "37", style: { top: "48%", left: "36%" } },
  { id: "38", style: { top: "62%", left: "36%" } },
  { id: "39", style: { top: "79%", left: "33%" } },
  { id: "40", style: { top: "13%", left: "92%" } },
  { id: "41", style: { top: "26%", left: "92%" } },
  { id: "42", style: { top: "38%", left: "92%" } },
  { id: "43", style: { top: "50%", left: "92%" } },
  { id: "44", style: { top: "62%", left: "90%" } },
  { id: "45", style: { top: "64%", left: "21%" } },
  { id: "46", style: { top: "53%", left: "21%" } },
  { id: "47", style: { top: "41%", left: "21%" } },
  { id: "48", style: { top: "18%", left: "21%" } },
  { id: "49", style: { top: "18%", left: "14%" } },
  { id: "50", style: { top: "29%", left: "21%" } },
  { id: "51", style: { top: "88%", left: "21%" } },
  { id: "52", style: { top: "88%", left: "41%" } },
  { id: "53", style: { top: "34%", left: "49%" } },
  { id: "54", style: { top: "89.5%", left: "69%" } },
  { id: "55", style: { top: "37%", left: "62%" } },
  { id: "56", style: { top: "75%", left: "31%" } },
  { id: "57", style: { top: "91%", left: "66%" } },
  { id: "58", style: { top: "38%", left: "92%" } },
  { id: "59", style: { top: "19%", left: "81%" } },
];

const formatDate = (date) =>
  date ? moment(date).utcOffset("+0700").format("DD-MM-YYYY") : "";

const initials = (name) =>
  name
    ? name
        .match(/(\b\S)?/g)
        .join("")
        .toUpperCase()
    : "";

// expired = sudah lewat, soon = kurang dari ~30 hari lagi
const getExpiry = (kadaluarsa) => {
  const today = new Date(moment().utcOffset("+0700").format());
  const soonDate = new Date(
    moment(kadaluarsa).utcOffset("+0700").add(-31, "days").format()
  );
  return {
    expired: new Date(kadaluarsa) <= today,
    soon: soonDate <= today,
  };
};

const MonitoringApar = () => {
  const {
    subMenu,
    setSubMenu,
    dataMerge,
    filterMesin,
    setFilterMesin,
    filterTahun,
    setFilterTahun,
    listApar,
    showQrCode,
    setShowQrCode,
    pickQrCode,
    setPickQrCode,
    listStatusApar,
    filterLantai,
    setFilterLantai,
    dateApar,
    setDateApar,
    filterNoApar,
    setFilterNoApar,
    dataTemp,
    exportKadaluarsa,
    sortApar,
    setSortApar,
  } = useApar();

  const [openItemId, setOpenItemId] = useState(null);

  const toggleItem = (itemId) => {
    setOpenItemId(openItemId === itemId ? null : itemId);
  };

  const listDataMap = [];
  if (listStatusApar) {
    listStatusApar.forEach((element) => {
      const foundObject = points.find((item) => item.id === element.noApar);
      if (foundObject) {
        listDataMap.push({
          ...foundObject,
          incoming: element.incoming,
          kadaluarsa: element.kadaluarsa,
          isKeluar: element.isKeluar,
          isNotif: element.isNotif,
          isTrouble: element.isTrouble,
          jenis: element.jenis,
          lantai: element.lantai,
          lastChecked: element.lastChecked,
          lastCheckedBy: element.lastCheckedBy,
          lastUsage: element.lastUsage,
          name: element.name,
        });
      }
    });
  }

  return (
    <div className="container-payroll">
      {showQrCode && (
        <PopUpComponent>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <QRCode
              size={136}
              value={pickQrCode.name}
              viewBox={`0 0 256 256`}
            />
            <p>No. APAR: {pickQrCode.noApar}</p>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="cancel_button"
              onClick={() => {
                setShowQrCode(false);
                setPickQrCode();
              }}
            >
              Tutup
            </button>
          </div>
        </PopUpComponent>
      )}

      <div className="wrapper-card-payroll padding-mobile-newsletter">
        {/* ===== Tabs ===== */}
        <div className="apar-tabs">
          {TABS.map(([key, label]) => (
            <button
              key={key}
              className={`apar-tab ${subMenu === key ? "is-active" : ""}`}
              onClick={() => setSubMenu(key)}
            >
              {label}
            </button>
          ))}
        </div>

        {/* ===== Monitoring ===== */}
        {subMenu === "monitoring" && (
          <>
            <div className="apar-toolbar">
              <select
                className="apar-select"
                value={filterLantai}
                onChange={(e) => setFilterLantai(e.target.value)}
              >
                <option value="1">Lantai 1</option>
                <option value="SATU SETENGAH">Lantai 1 Setengah</option>
                <option value="2">Lantai 2</option>
                <option value="BASEMENT">Basement</option>
                <option value="PARKIRAN">Parkiran</option>
              </select>
            </div>

            <div className="apar-legend">
              <span>
                <i style={{ background: "var(--apar-ok)" }} />
                Aktif
              </span>
              <span>
                <i style={{ background: "var(--apar-soon)" }} />
                Kadaluarsa &lt; 30 hari
              </span>
              <span>
                <i style={{ background: "var(--apar-trouble)" }} />
                Keluar / Trouble
              </span>
              <span>
                <i style={{ background: "var(--apar-expired)" }} />
                Kadaluarsa
              </span>
            </div>

            <div className="apar-wrapper">
              <img
                src={FLOOR_IMAGES[filterLantai] || ""}
                alt={`Denah ${filterLantai}`}
                style={{ width: "100%", display: "block" }}
              />
              {listDataMap.map((p) => {
                const { expired, soon } = getExpiry(p.kadaluarsa);
                const iconClass =
                  (p.isKeluar || p.isTrouble) && !expired
                    ? "apar-icon-isTrouble"
                    : expired
                    ? "apar-icon-inactive"
                    : soon
                    ? "apar-icon-thirty-days"
                    : "apar-icon-active";

                return (
                  <div className="apar" key={p.id} style={p.style}>
                    <img src={AparIcon} className={iconClass} alt="APAR" />
                    <div className="popup">
                      APAR No: <b>{p.id}</b>
                      <br />
                      Jenis: {p.jenis}
                      <br />
                      Diperiksa: {formatDate(p.lastChecked)} -{" "}
                      <b>{initials(p.lastCheckedBy)}</b>
                      <br />
                      <span style={expired ? { color: "#ff8787" } : {}}>
                        Kadaluarsa: {formatDate(p.kadaluarsa)}
                      </span>
                      <br />
                      <span style={p.isKeluar ? { color: "#ffdd00" } : {}}>
                        Keluar: {p.isKeluar ? "YES" : "NO"}
                      </span>
                      <br />
                      <span style={p.isTrouble ? { color: "#ff8787" } : {}}>
                        Trouble: {p.isTrouble ? "YES" : "NO"}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {/* ===== Checksheet ===== */}
        {subMenu === "checksheet" && (
          <div>
            <div className="apar-toolbar">
              <select
                className="apar-select"
                onChange={(e) => setFilterMesin(e.target.value)}
                value={filterMesin}
              >
                {apar.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </select>
              <select
                className="apar-select"
                value={filterTahun}
                onChange={(e) => setFilterTahun(e.target.value)}
              >
                {tahun.map((e) => (
                  <option key={e} value={e}>
                    {e}
                  </option>
                ))}
              </select>
            </div>

            <div className="apar-table-scroll">
              <table className="apar-table">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Item Check</th>
                    <th>Standar</th>
                    {bulan &&
                      bulan.map((data) => (
                        <th key={data.value} style={{ textAlign: "center" }}>
                          {data.name.slice(0, 3)}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {dataMerge &&
                    dataMerge.map((data, index) => (
                      <tr key={data.itemId ?? index}>
                        <td className="td-checklist-apar">{index + 1}.</td>
                        <td className="td-checklist-apar">{data.itemCheck}</td>
                        <td className="td-checklist-apar">{data.standar}</td>
                        {bulan.map((ele) => {
                          const foundObject = data.month.find(
                            (obj) =>
                              obj.monthId === ele.value &&
                              obj.itemId === data.itemId
                          );

                          if (!foundObject) {
                            return (
                              <td
                                key={ele.value}
                                className="td-checklist-apar"
                              />
                            );
                          }

                          return (
                            <td key={ele.value} className="td-checklist-apar">
                              {typeof foundObject.checklist === "boolean" ? (
                                <img
                                  src={foundObject.checklist ? Check : Cross}
                                  alt={
                                    foundObject.checklist ? "OK" : "Tidak OK"
                                  }
                                  style={{ width: "22px" }}
                                />
                              ) : typeof foundObject.checklist === "number" ? (
                                <span>{foundObject.checklist} Kg</span>
                              ) : (
                                <b>{initials(foundObject.petugas)}</b>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* ===== In / Out ===== */}
        {subMenu === "InOut" && (
          <>
            <div className="apar-toolbar">
              <input
                className="apar-input"
                type="date"
                value={dateApar}
                onChange={(e) => setDateApar(e.target.value)}
              />
              <select
                className="apar-select"
                value={filterNoApar}
                onChange={(e) => setFilterNoApar(e.target.value)}
              >
                <option disabled value="Pilih Apar">
                  Pilih Apar
                </option>
                {apar.map((ele) => (
                  <option key={ele} value={ele}>
                    {ele}
                  </option>
                ))}
              </select>
              <select
                className="apar-select"
                value={sortApar}
                onChange={(e) => setSortApar(e.target.value)}
              >
                <option value="asc">No. APAR: A-Z</option>
                <option value="desc">No. APAR: Z-A</option>
              </select>
              <button
                className="button-kirim-apar"
                style={{ background: "#81bfda" }}
                onClick={() => setFilterNoApar("Pilih Apar")}
              >
                Reset
              </button>
            </div>

            {dataTemp &&
              dataTemp.map((ele, i) => (
                <AccordionApar
                  key={`${ele.noApar}-${i}`}
                  data={ele}
                  mock={mock}
                  isOpen={openItemId === ele.noApar}
                  onClick={() => toggleItem(ele.noApar)}
                />
              ))}
          </>
        )}

        {/* ===== Inventory ===== */}
        {subMenu === "Inventory" && (
          <div>
            <div className="apar-toolbar">
              <button
                className="button-kirim-apar apar-toolbar-end"
                style={{ background: "green" }}
                onClick={() => exportKadaluarsa()}
              >
                Export Data APAR
              </button>
            </div>

            <div className="apar-table-scroll">
              <table className="apar-table">
                <thead>
                  <tr>
                    <th>APAR</th>
                    <th>Jenis</th>
                    <th>Status</th>
                    <th>Lantai</th>
                    <th>Kadaluarsa</th>
                    <th>Last Check</th>
                    <th>Petugas</th>
                    <th style={{ textAlign: "center" }}>QR</th>
                  </tr>
                </thead>
                <tbody>
                  {listApar &&
                    listApar.map((data, index) => {
                      const { expired, soon } = getExpiry(data.kadaluarsa);
                      return (
                        <tr key={`${data.noApar}-${index}`}>
                          <td style={{ textAlign: "center" }}>
                            {data.noApar}.
                          </td>
                          <td>{data.jenis}</td>
                          <td>
                            <span
                              className={`badge ${
                                data.isKeluar ? "badge-keluar" : "badge-aktif"
                              }`}
                            >
                              {data.isKeluar ? "Keluar" : "Aktif"}
                            </span>
                          </td>
                          <td>{data.lantai}</td>
                          <td>
                            <span
                              className={`exp ${
                                expired
                                  ? "exp-expired"
                                  : soon
                                  ? "exp-soon"
                                  : "exp-ok"
                              }`}
                            >
                              {formatDate(data.kadaluarsa)}
                            </span>
                          </td>
                          <td>{formatDate(data.lastChecked)}</td>
                          <td>{data.lastCheckedBy}</td>
                          <td
                            style={{ textAlign: "center", cursor: "pointer" }}
                          >
                            <img
                              src={Barcode}
                              alt="Lihat QR"
                              style={{ width: "24px" }}
                              onClick={() => {
                                setShowQrCode(true);
                                setPickQrCode(data);
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MonitoringApar;
